'use client';

import { TopBar as SingleMatchTopBar } from '@/features/single-match/top-bar';
import { SportMatchModel } from '@nf/types/odds';
interface VirtualSportMatchPanelProps {
	match: SportMatchModel;
}
export const VirtualSportMatchPanel = (virtualSportMatchPanelProps: VirtualSportMatchPanelProps) => {
	const { match } = virtualSportMatchPanelProps;
	return (
		<div className="aside-panel aside-panel--video">
			<SingleMatchTopBar
				match={match}
				isAsideLayout={true}
			/>
			<h2>Virutal Sport Video</h2>
			<p>Here is the virtual sport video content...</p>
		</div>
	);
}